// import React, { useState } from "react";
// import {
//   Grid,
//   Typography,
//   Card,
//   CardContent,
//   Container,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Box,
// } from "@mui/material";

// const DissertationServices: React.FC = () => {
//   const data = {
//     title: "Dissertation",
//     additionalInfo: [
//       {
//         title: "Topic selection",
//         description:
//           "Our company offers comprehensive services in topic selection and assignment writing, providing clients with expert guidance throughout the writing process. We assist in identifying relevant and engaging topics, conducting thorough research, and ensuring high-quality content through meticulous editing. Our goal is to empower clients to produce well-structured and insightful assignments that meet their academic or professional needs.",
//         image: "ds2.webp",
//         cards: [
//           {
//             title: "Importance of Topic Selection",
//             description:
//               "Choosing the right topic is the foundation of any successful assignment. A well-chosen topic ensures that the research is focused, relevant, coherent arguments.",
//           },
//           {
//             title: "Research Support",
//             description:
//               "Effective research is key to producing high-quality content. By offering research assistance, we ensure that clients gather credible and relevant sources, enhancing the depth and accuracy of their assignments.",
//           },
//           {
//             title: "Editing and Proofreading",
//             description:
//               "After the writing process, thorough editing and proofreading are essential. This ensures that the assignment is free from errors, follows proper formatting guidelines, and maintains a professional tone throughout.",
//           },
//           {
//             title: "Tailored Writing Assistance",
//             description:
//               "Every assignment is unique, and we provide customized writing support to meet specific academic or professional requirements. From topic selection to the final draft, we tailor our services to match the needs of our clients.",
//           },
//         ],
//       },
//       {
//         title: "Problem Identification",
//         description:
//           "Problem identification in assignment writing is crucial to ensure a smooth and successful writing process. Common issues include unclear guidelines, choosing topics that are either too broad or too narrow, and difficulties in conducting effective research. Additionally, time management challenges often lead to rushed or incomplete work. By identifying these problems early, clients can receive the right support, ensuring clarity, focused research, and timely completion of their assignments.",
//         image: "/api/placeholder/400/300",
//         cards: [
//           {
//             title: "Unclear Assignment Guidelines",
//             description:
//               "Students often struggle with vague or incomplete instructions, leading to confusion about the assignment's goals. Identifying this issue early helps clarify expectations and ensures the topic selection aligns with the instructor's criteria.",
//           },
//           {
//             title: "Broad or Narrow Topics",
//             description:
//               "Choosing a topic that is too broad can result in a lack of focus, while a topic that is too narrow might not have enough research material. Helping clients identify this problem ensures they select a topic that is manageable and researchable.",
//           },
//           {
//             title: "Inadequate Research Skills",
//             description:
//               "Many clients face difficulty in finding credible sources or organizing research effectively. By recognizing this challenge, we provide targeted research support, helping them gather and analyze information efficiently.",
//           },
//           {
//             title: "Poor Time Management",
//             description:
//               "Some clients struggle with deadlines, leading to rushed or incomplete assignments. Identifying time management issues allows us to offer structured guidance and ensure timely progress through each stage of the assignment.",
//           },
//         ],
//       },
//       {
//         title: "Research proposal",
//         description:
//           "A research proposal in assignment writing outlines the plan for investigating a specific topic or question. It includes the research objectives, methodology, and a brief overview of relevant literature. The proposal sets the foundation for the assignment, helping to define the scope of research and guide the writing process. A well-crafted proposal ensures clarity, structure, and a focused approach, making it easier to develop a compelling and cohesive final paper.",
//         image: "/api/placeholder/400/300",
//         cards: [
//           {
//             title: "Research Objectives",
//             description:
//               "Defining clear and concise research objectives is essential for a strong proposal. These objectives guide the scope of the research and set the direction for what the assignment aims to achieve.",
//           },
//           {
//             title: "Literature Review",
//             description:
//               "A brief review of existing literature helps establish the context of the research. It highlights gaps in current knowledge and justifies the need for the proposed study, ensuring the research is relevant and well-grounded.",
//           },
//           {
//             title: "Research Methodology",
//             description:
//               "The methodology outlines the approach to collecting and analyzing data. Whether qualitative or quantitative, this section explains how the research will be conducted, ensuring clarity and feasibility in the execution of the study.",
//           },
//           {
//             title: "Significance of the Study",
//             description:
//               "This topic emphasizes the importance of the research and its potential contributions. Highlighting the significance ensures that the proposal not only aligns with academic standards but also demonstrates the value and impact of the study.",
//           },
//         ],
//       },
//       {
//         title: "Dissertation (Full)",
//         description:
//           "A dissertation is a comprehensive research project that marks the culmination of a degree program. It involves selecting a topic, conducting thorough research, analyzing data, and presenting findings in a structured format. A successful dissertation demonstrates strong research skills, critical thinking, and contributes original insights to the field of study. It is a key academic milestone, showcasing a student's expertise and dedication.",
//         image: "/api/placeholder/400/300",
//         cards: [
//           {
//             title: "Proposal Development",
//             description:
//               "The dissertation proposal is the initial step where students outline their research plan, objectives, and methodology. This topic is important because it sets the framework for the entire dissertation and must gain approval before proceeding with the full study.",
//           },
//           {
//             title: "Data Collection Techniques",
//             description:
//               "Choosing the right data collection techniques, such as surveys, interviews, or experiments, is essential for gathering accurate and reliable information. This topic focuses on how data will be sourced and ensures that the chosen methods align with the research objectives.",
//           },
//           {
//             title: "Ethical Considerations",
//             description:
//               "Addressing ethical issues is crucial in dissertation writing. This includes obtaining consent from participants, ensuring confidentiality, and avoiding plagiarism. Ethical practices help protect the integrity of the research and its results.",
//           },
//           {
//             title: "Dissertation Structure and Formatting",
//             description:
//               "The structure and formatting of a dissertation are critical to its readability and professionalism. This topic emphasizes the importance of following academic guidelines, organizing chapters logically, and maintaining clarity and consistency throughout the document.",
//           },
//         ],
//       },
//       {
//         title: "Dissertation (Part-Time)",
//         description:
//           "A dissertation part in assignment writing refers to a specific section, such as the literature review or methodology, that contributes to the overall project. Each part serves a crucial role, with the literature review summarizing existing research and the methodology detailing data collection methods. Well-structured and cohesive sections are essential for clarity and effectively supporting the dissertation's objectives.",
//         image: "/api/placeholder/400/300",
//         cards: [
//           {
//             title: "Introduction",
//             description:
//               "The introduction sets the stage for the dissertation by presenting the research problem, objectives, and significance of the study. It engages the reader and provides a clear overview of what to expect in the subsequent sections, establishing the context for the research.",
//           },
//           {
//             title: "Theoretical Framework",
//             description:
//               "The theoretical framework explains the theories and concepts that underpin the research. This part helps to guide the study's analysis and interpretation, illustrating how existing theories relate to the research question and framing the research within a broader academic context.",
//           },
//           {
//             title: "Limitations and Delimitations",
//             description:
//               "This section addresses the limitations of the study, such as constraints in data collection or potential biases, while also outlining the boundaries set by the researcher (delimitations). Acknowledging these factors enhances the transparency and credibility of the research.",
//           },
//           {
//             title: "References and Appendices",
//             description:
//               "The references section lists all the sources cited throughout the dissertation, ensuring academic integrity. The appendices may include additional materials, such as questionnaires or raw data, that support the research but are not included in the main text, providing supplementary information for readers.",
//           },
//         ],
//       },
//       {
//         title: "Consultation",
//         description:
//           "Consultation in assignment writing involves seeking guidance from experts or mentors to improve the quality of work. It helps students clarify doubts, refine topics, and gain insights into effective research methods. Engaging in consultation enhances understanding of assignment requirements and contributes to more coherent and well-structured submissions.",
//         image: "/api/placeholder/400/300",
//         cards: [
//           {
//             title: "Identifying the Right Consultant",
//             description:
//               "Choosing the appropriate consultant or mentor is crucial for effective guidance. This topic emphasizes the importance of selecting individuals with expertise in the relevant subject area, ensuring that the advice received is relevant and beneficial.",
//           },
//           {
//             title: "Preparing for Consultations",
//             description:
//               "Preparation is key to maximizing the benefits of consultations. This involves outlining specific questions or concerns and gathering relevant materials in advance, enabling focused discussions and efficient use of time during meetings.",
//           },
//           {
//             title: "Incorporating Feedback",
//             description:
//               "Understanding how to effectively incorporate feedback from consultations is essential. This topic explores strategies for analyzing and applying suggestions to improve the assignment, helping students enhance their writing and research.",
//           },
//           {
//             title: "Continuous Learning and Support",
//             description:
//               "Consultation is not just a one-time event but an ongoing process that supports continuous learning. This topic emphasizes the importance of seeking regular feedback throughout the assignment process, ensuring progress and addressing any challenges as they arise.",
//           },
//         ],
//       },
//     ],
//   };

//   const [activeIndex, setActiveIndex] = useState<number | null>(0);

//   return (
//     <Container maxWidth={false} disableGutters>
//       <Grid container spacing={0} sx={{ backgroundColor: "#172554" }}>
//         {/* Left Side - Category List */}
//         <Grid item xs={12} md={3}>
//           <List>
//             {data.additionalInfo.map((info, index) => (
//               <ListItem
//                 button
//                 key={index}
//                 onClick={() => setActiveIndex(index)}
//                 selected={activeIndex === index}
//                 sx={{color:'white'}}
//               >
//                 <ListItemText primary={info.title}  />
//               </ListItem>
//             ))}
//           </List>
//         </Grid>

//         {/* Right Side - Title, Image, Description, and Cards */}
//         <Grid item xs={12} md={9}>
//           {activeIndex !== null && (
//             <Paper
//               elevation={3}
//               sx={{
//                 padding: 3,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 backgroundColor: "#f3f4f6",
//                 boxShadow: "none",
//                 borderRadius: "0px",
//               }}
//             >
//               <Typography variant="h5" sx={{ marginBottom: 2 }}>
//                 {data.additionalInfo[activeIndex].title}
//               </Typography>
//               <Box sx={{ marginBottom: 2 }}>
//                 <img
//                   src={data.additionalInfo[activeIndex].image}
//                   alt={data.additionalInfo[activeIndex].title}
//                   style={{
//                     width: "100%",
//                     height: "auto",
//                     maxHeight: "150px",
//                     objectFit: "cover",
//                   }}
//                 />
//               </Box>
//               <Typography sx={{ marginBottom: 4,textAlign:"center" }}>
//                 {data.additionalInfo[activeIndex].description}
//               </Typography>

//               <Grid
//                 container
//                 direction="column"
//                 spacing={2}
//                 sx={{
//                   backgroundColor: "#172554",
//                   color: "white",
//                   borderRadius:"4px",
//                   maxWidth: { lg: "75%", xs: "100%" },
//                 }}
//               >
//                 {data.additionalInfo[activeIndex].cards.map((card, index) => (
//                   <Grid item key={index}>
//                     <Card
//                       sx={{
//                         boxShadow: "none",
//                         backgroundColor: "transparent",
//                         color: "white",
//                       }}
//                     >
//                       <CardContent
//                         sx={{
//                           display: "flex",
//                           flexDirection: "column",
//                           alignItems: "center",
//                         }}
//                       >
//                         <Typography variant="h6">
//                           <i
//                             className="fa-solid fa-circle-check"
//                             style={{ color: "#f97316", paddingRight: "10px" }}
//                           ></i>
//                           {card.title}
//                         </Typography>
//                         <Typography variant="body2" textAlign={"center"} >
//                           {card.description}
//                         </Typography>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Paper>
//           )}
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default DissertationServices;

import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Container,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const DissertationServices: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const otherServices = [
    { title: "Coursework", route: "/coursework-writing" },
    { title: "Data analytics", route: "/data-analysis-services" },
    { title: "Project writing services", route: "/project-report-writing" },
    { title: "Publication", route: "/publication-services" },
    { title: "Literature review", route: "/literature-review-writing" },
    { title: "Manuscript", route: "/manuscript-preparation" },
    { title: "Research methodology", route: "/research-methodology-services" },
  ];

  const data = {
    icon: "ds2.webp",
    title: "Dissertation",
    image: "ds2.webp",
    description:
      "Transform your data science assignments into standout projects with our PhD-level expertise.",
    additionalInfo: [
      {
        title: "Topic selection",
        icon1: "ds2.webp",
        description:
          "Our company offers comprehensive services in topic selection and assignment writing, providing clients with expert guidance throughout the writing process. We assist in identifying relevant and engaging topics, conducting thorough research, and ensuring high-quality content through meticulous editing. Our goal is to empower clients to produce well-structured and insightful assignments that meet their academic or professional needs.",
        cards: [
          {
            title: "Importance of Topic Selection",

            description:
              "Choosing the right topic is the foundation of any successful assignment. A well-chosen topic ensures that the research is focused, relevant, coherent arguments.",
          },

          {
            title: "Research Support",
            description:
              "Effective research is key to producing high-quality content. By offering research assistance, we ensure that clients gather credible and relevant sources, enhancing the depth and accuracy of their assignments.",
          },
          {
            title: "Editing and Proofreading",

            description:
              "After the writing process, thorough editing and proofreading are essential. This ensures that the assignment is free from errors, follows proper formatting guidelines, and maintains a professional tone throughout.",
          },
          {
            title: "Tailored Writing Assistance",

            description:
              "Every assignment is unique, and we provide customized writing support to meet specific academic or professional requirements. From topic selection to the final draft, we tailor our services to match the needs of our clients.",
          },
        ],
      },
      {
        title: "Problem Identification",
        icon1: "",
        description:
          "Problem identification in assignment writing is crucial to ensure a smooth and successful writing process. Common issues include unclear guidelines, choosing topics that are either too broad or too narrow, and difficulties in conducting effective research. Additionally, time management challenges often lead to rushed or incomplete work. By identifying these problems early, clients can receive the right support, ensuring clarity, focused research, and timely completion of their assignments.",

        cards: [
          {
            title: "Unclear Assignment Guidelines",

            description:
              "Students often struggle with vague or incomplete instructions, leading to confusion about the assignment's goals. Identifying this issue early helps clarify expectations and ensures the topic selection aligns with the instructor’s criteria.",
          },
          {
            title: "Broad or Narrow Topics",
            description:
              "Choosing a topic that is too broad can result in a lack of focus, while a topic that is too narrow might not have enough research material. Helping clients identify this problem ensures they select a topic that is manageable and researchable.",
          },
          {
            title: "Inadequate Research Skills",

            description:
              "Many clients face difficulty in finding credible sources or organizing research effectively. By recognizing this challenge, we provide targeted research support, helping them gather and analyze information efficiently.",
          },
          {
            title: "Poor Time Management",

            description:
              "Some clients struggle with deadlines, leading to rushed or incomplete assignments. Identifying time management issues allows us to offer structured guidance and ensure timely progress through each stage of the assignment.",
          },
        ],
      },
      {
        title: "Research proposal",
        icon1: "",
        description:
          "A research proposal in assignment writing outlines the plan for investigating a specific topic or question. It includes the research objectives, methodology, and a brief overview of relevant literature. The proposal sets the foundation for the assignment, helping to define the scope of research and guide the writing process. A well-crafted proposal ensures clarity, structure, and a focused approach, making it easier to develop a compelling and cohesive final paper.",

        cards: [
          {
            title: "Research Objectives",

            description:
              "Defining clear and concise research objectives is essential for a strong proposal. These objectives guide the scope of the research and set the direction for what the assignment aims to achieve.",
          },
          {
            title: "Literature Review",

            description:
              "A brief review of existing literature helps establish the context of the research. It highlights gaps in current knowledge and justifies the need for the proposed study, ensuring the research is relevant and well-grounded.",
          },
          {
            title: "Research Methodology",

            description:
              "The methodology outlines the approach to collecting and analyzing data. Whether qualitative or quantitative, this section explains how the research will be conducted, ensuring clarity and feasibility in the execution of the study.",
          },
          {
            title: "Significance of the Study",
            description:
              "This topic emphasizes the importance of the research and its potential contributions. Highlighting the significance ensures that the proposal not only aligns with academic standards but also demonstrates the value and impact of the study.",
          },
        ],
      },
      {
        title: "Dissertation(Full)",
        icon1: "",
        description:
          "A dissertation is a comprehensive research project that marks the culmination of a degree program. It involves selecting a topic, conducting thorough research, analyzing data, and presenting findings in a structured format. A successful dissertation demonstrates strong research skills, critical thinking, and contributes original insights to the field of study. It is a key academic milestone, showcasing a student's expertise and dedication.",

        cards: [
          {
            title: "Proposal Development",

            description:
              "The dissertation proposal is the initial step where students outline their research plan, objectives, and methodology. This topic is important because it sets the framework for the entire dissertation and must gain approval before proceeding with the full study.",
          },
          {
            title: "Data Collection Techniques",

            description:
              "Choosing the right data collection techniques, such as surveys, interviews, or experiments, is essential for gathering accurate and reliable information. This topic focuses on how data will be sourced and ensures that the chosen methods align with the research objectives.",
          },
          {
            title: "Ethical Considerations",

            description:
              "Addressing ethical issues is crucial in dissertation writing. This includes obtaining consent from participants, ensuring confidentiality, and avoiding plagiarism. Ethical practices help protect the integrity of the research and its results.",
          },
          {
            title: "Dissertation Structure and Formatting",

            description:
              "The structure and formatting of a dissertation are critical to its readability and professionalism. This topic emphasizes the importance of following academic guidelines, organizing chapters logically, and maintaining clarity and consistency throughout the document.",
          },
        ],
      },
      {
        title: "Dissertation(Part-Time)",
        icon1: "",
        description:
          "A dissertation part in assignment writing refers to a specific section, such as the literature review or methodology, that contributes to the overall project. Each part serves a crucial role, with the literature review summarizing existing research and the methodology detailing data collection methods. Well-structured and cohesive sections are essential for clarity and effectively supporting the dissertation’s objectives.",

        cards: [
          {
            title: "Introduction",

            description:
              "The introduction sets the stage for the dissertation by presenting the research problem, objectives, and significance of the study. It engages the reader and provides a clear overview of what to expect in the subsequent sections, establishing the context for the research.",
          },
          {
            title: "Theoretical Framework",

            description:
              "The theoretical framework explains the theories and concepts that underpin the research. This part helps to guide the study’s analysis and interpretation, illustrating how existing theories relate to the research question and framing the research within a broader academic context.",
          },
          {
            title: "Limitations and Delimitations",

            description:
              "This section addresses the limitations of the study, such as constraints in data collection or potential biases, while also outlining the boundaries set by the researcher (delimitations). Acknowledging these factors enhances the transparency and credibility of the research.",
          },
          {
            title: "References and Appendices",

            description:
              "The references section lists all the sources cited throughout the dissertation, ensuring academic integrity. The appendices may include additional materials, such as questionnaires or raw data, that support the research but are not included in the main text, providing supplementary information for readers.",
          },
        ],
      },
      {
        title: "Consultion",
        icon1: "",
        description:
          "Consultation in assignment writing involves seeking guidance from experts or mentors to improve the quality of work. It helps students clarify doubts, refine topics, and gain insights into effective research methods. Engaging in consultation enhances understanding of assignment requirements and contributes to more coherent and well-structured submissions.",

        cards: [
          {
            title: "Identifying the Right Consultant",

            description:
              "Choosing the appropriate consultant or mentor is crucial for effective guidance. This topic emphasizes the importance of selecting individuals with expertise in the relevant subject area, ensuring that the advice received is relevant and beneficial.",
          },
          {
            title: "Preparing for Consultations",

            description:
              "Preparation is key to maximizing the benefits of consultations. This involves outlining specific questions or concerns and gathering relevant materials in advance, enabling focused discussions and efficient use of time during meetings.",
          },
          {
            title: "Incorporating Feedback",

            description:
              "Understanding how to effectively incorporate feedback from consultations is essential. This topic explores strategies for analyzing and applying suggestions to improve the assignment, helping students enhance their writing and research.",
          },
          {
            title: "Continuous Learning and Support",

            description:
              "Consultation is not just a one-time event but part of a continuous learning process. This topic highlights the importance of ongoing support and feedback throughout the assignment writing journey, fostering growth and improvement in academic skills.",
          },
        ],
      },
      {
        title: "Viva Voce",
        icon1: "",
        description:
          "A viva voce in assignment writing is an oral examination where students defend their research findings and methodology before a panel. This process allows candidates to demonstrate their understanding of the subject, engage in critical discussion, and clarify any uncertainties. A successful viva voce showcases the student's ability to articulate their research and justify their conclusions, making it a vital part of the assessment.",

        cards: [
          {
            title: "Preparation Techniques",

            description:
              "Effective preparation is essential for a successful viva voce. This topic focuses on strategies such as reviewing key concepts, practicing responses to potential questions, and familiarizing oneself with the research material to boost confidence and performance during the examination.",
          },
          {
            title: "Common Questions and Themes",

            description:
              "Understanding common questions and themes that arise during a viva voce helps students anticipate what to expect. This topic includes typical inquiries about the research process, findings, and implications, enabling candidates to prepare targeted responses.",
          },
          {
            title: "Presentation Skills",

            description:
              "Strong presentation skills are crucial during a viva voce. This topic emphasizes the importance of clear communication, body language, and engaging the panel effectively. Developing these skills enhances the candidate's ability to convey their research confidently.",
          },
          {
            title: "Receiving Feedback",

            description:
              "How to receive and respond to feedback during the viva is a critical aspect of the process. This topic highlights the importance of active listening, addressing panel comments constructively, and demonstrating a willingness to engage in scholarly discussion.",
          },
        ],
      },
      {
        title: "Pilot Study",
        icon1: "",
        description:
          "A study pilot in assignment writing is a small-scale trial run conducted before the main research. It helps test the feasibility of the research design, methods, and data collection tools. By identifying potential issues early, a study pilot allows for adjustments to improve the overall quality and accuracy of the final research, ensuring that the full study runs smoothly and produces reliable results.",

        cards: [
          {
            title: "Purpose of a Study Pilot",

            description:
              "The purpose of a study pilot is to test the feasibility of the research design and methods before the full-scale study. This helps identify potential problems, such as unclear questions or ineffective data collection tools, ensuring the main study runs smoothly.",
          },
          {
            title: "Pilot Data Collection",

            description:
              "Data collection in a pilot study allows researchers to test their instruments, such as surveys or interviews, on a small sample. This process ensures that the tools are effective and adjustments can be made before the full study begins.",
          },
          {
            title: "Identifying Limitations",

            description:
              "A pilot study helps identify limitations or challenges that may arise during the main research. By spotting these early, researchers can refine their approach, improving the reliability and validity of their final study.",
          },
          {
            title: "Evaluating Methodology",

            description:
              "The pilot also evaluates the chosen methodology to ensure it aligns with the research objectives. It helps verify if the methods are suitable for achieving accurate and meaningful results, reducing the likelihood of errors in the full study.",
          },
        ],
      },
    ],
  };
  const handleServiceClick = (route: string) => {
    window.location.href = route;
  };

  const handleHeadingClick = (index: number) => {
    setActiveIndex(activeIndex === index ? 0 : index);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: "#172554",
          padding: { sm: 0, lg: 3 },
          display: "flex",
          flexDirection: "row-reverse",
        }}
        className="component"
      >
        {/* Left Side - Other Services List (Desktop) and Expandable Headings (Mobile) */}
        <Grid item xs={12} md={3}>
          {/* Desktop View */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <List>
              {data.additionalInfo.map((info, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleHeadingClick(index)}
                  selected={activeIndex === index}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={info.title} />
                </ListItem>
              ))}
              <Typography
                sx={{ textAlign: "center", color: "white", fontWeight: "bold" }}
              >
                Our Other Services
              </Typography>
              {otherServices.map((service, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleServiceClick(service.route)}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={service.title} />
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Mobile View - Expandable Headings */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {data.additionalInfo.map((info, index) => (
              <Box key={index}>
                <ListItem
                  button
                  onClick={() => handleHeadingClick(index)}
                  sx={{
                    color: "white",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <ListItemText primary={info.title} />
                  <IconButton sx={{ color: "white" }}>
                    {activeIndex === index ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                </ListItem>
                <Collapse
                  in={activeIndex === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      backgroundColor: "#f3f4f6",
                      color: "black",
                      padding: 2,
                    }}
                  >
                    <Typography variant="body2" sx={{ marginBottom: 2 }}>
                      {info.description}
                    </Typography>
                    {info.cards.map((card, cardIndex) => (
                      <Card
                        key={cardIndex}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: "#172554",
                          color: "white",
                        }}
                      >
                        <CardContent>
                          <Typography variant="h6" >
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2">
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Collapse>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Right Side - Dissertation Content (Desktop Only) */}
        <Grid item md={9} sx={{ display: { xs: "none", md: "block" } }}>
          <Paper
            elevation={3}
            sx={{
              padding: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#f3f4f6",
              boxShadow: "none",
              borderRadius: "0px",
            }}
          >
            {activeIndex !== null && (
              <>
                <Typography variant="h5" sx={{ marginBottom: 2 }}>
                  {data.additionalInfo[activeIndex].title}
                </Typography>
                <Box sx={{ marginBottom: 2 }}></Box>
                <Typography sx={{ marginBottom: 4, textAlign: "center" }}>
                  {data.additionalInfo[activeIndex].description}
                </Typography>

                <Grid
                  container
                  direction="column"
                  spacing={2}
                  sx={{
                    backgroundColor: "#172554",
                    color: "white",
                    borderRadius: "4px",
                    maxWidth: { lg: "75%", xs: "100%" },
                  }}
                >
                  {data.additionalInfo[activeIndex].cards.map((card, index) => (
                    <Grid item key={index}>
                      <Card
                        sx={{
                          boxShadow: "none",
                          backgroundColor: "transparent",
                          color: "white",
                        }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="h6" color={'white'}>
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2" textAlign={"center"}>
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DissertationServices;
